import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/state/redux';
import { PromptType, PromptStatus } from '@alucio/aws-beacon-amplify/src/models';

export const selectPromptValuesState = (state: RootState) => state.promptValues;

export const selectPromptValuesLoading = createSelector(
  [selectPromptValuesState],
  (promptValuesState) => promptValuesState.isLoading,
);

export const selectAllPromptValues = createSelector(
  [selectPromptValuesState],
  (promptValuesState) => promptValuesState.records.filter((value) => value.status !== PromptStatus.DELETED),
);

export const selectActivePromptValuesByType = createSelector(
  [
    selectAllPromptValues,
    (_state: RootState, promptType: PromptType) => promptType,
  ],
  (allValues, promptType) =>
    allValues.filter(
      (value) =>
        value.promptType === promptType &&
        value.status === PromptStatus.ACTIVE,
    ),
);

export const selectActiveComplianceRules = createSelector(
  [selectAllPromptValues],
  (allValues) =>
    allValues.filter(
      (value) =>
        value.promptType === PromptType.DECK_COMPLIANCE_RULE &&
        value.status === PromptStatus.ACTIVE,
    ),
);

export const selectComplianceLoading = selectPromptValuesLoading;

export const selectActiveAISummaryDocTypes = createSelector(
  [selectAllPromptValues],
  (allValues) =>
    allValues.filter(
      (value) =>
        value.promptType === PromptType.AI_SUMMARY_DOC_TYPE &&
        value.status === PromptStatus.ACTIVE,
    ),
);
